import { render, staticRenderFns } from "./navigationTabs.vue?vue&type=template&id=4b9fb380&"
import script from "./navigationTabs.vue?vue&type=script&lang=js&"
export * from "./navigationTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports